module.exports = __webpack_public_path__ + "img/TV_clean_box30.f7ed32e2.jpg";